/**
 * Lời nhắn xin quyền gửi Admin (đặc tả §4, phương án B). Chỉ soạn trên máy, không gọi API.
 */

export type RequestedRole = 'MOD' | 'ADMIN';

export const ROLE_LABELS: Record<RequestedRole, string> = {
  MOD: 'MOD',
  ADMIN: 'Admin',
};

export interface AccessRequest {
  fullName: string;
  email: string;
  role: RequestedRole;
}

export const composeAccessMessage = ({ fullName, email, role }: AccessRequest) =>
  `Chào Admin, mình là ${fullName.trim()}. Nhờ Admin cấp quyền ${
    ROLE_LABELS[role]
  } trên trang quản trị HP Media cho tài khoản ${email}. Cảm ơn!`;

/** Cách cũ cho trang mở qua http không phải localhost (navigator.clipboard chỉ có ở https). */
const copyWithTextarea = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  const previousFocus = document.activeElement as HTMLElement | null;
  textarea.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  document.body.removeChild(textarea);
  previousFocus?.focus?.();
  return ok;
};

/** Chép vào clipboard. Trả `false` nếu trình duyệt không cho — khi đó trang hiện ô để tự chép. */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Bị từ chối quyền / không ở secure context: thử cách cũ bên dưới.
  }
  try {
    return copyWithTextarea(text);
  } catch {
    return false;
  }
}
